import type { SmsChat } from "@stockline/shared/types/communications/sms-chat"
import type { OfflineResourceConfig } from "../../../types"
import { SMS_CHAT_TABLE } from "./db"

export const smsChatConfig: OfflineResourceConfig<SmsChat> = {
  name: "sms-chats",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  endpoints: {
    full: "/api/v2/sms-chats",
    delta: "/api/v2/sms-chats/changes",
    push: "/api/v2/sms-chats/changes",
  },
  tableName: SMS_CHAT_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    accountId: "accountId",
    archived: "archived",
    enabled: "enabled",
    lastMessageDate: "lastMessageDate",
    syncId: "syncId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
